import clsx from 'clsx';

interface PostcardStandardProps {
  className?: string;
}

const PostcardStandard: React.FC<PostcardStandardProps> = ({ className }) => {
	return (
		<svg
			className={clsx('postcard-standard', className)}
			fill="none"
			height="96"
			viewBox="0 0 136 96"
			width="136"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8 0.5H128C132.142 0.5 135.5 3.85786 135.5 8V88C135.5 92.1421 132.142 95.5 128 95.5H8C3.85786 95.5 0.5 92.1421 0.5 88V8C0.5 3.85786 3.85786 0.5 8 0.5Z"
				fill="white"
			/>
			<path
				d="M8 0.5H128C132.142 0.5 135.5 3.85786 135.5 8V88C135.5 92.1421 132.142 95.5 128 95.5H8C3.85786 95.5 0.5 92.1421 0.5 88V8C0.5 3.85786 3.85786 0.5 8 0.5Z"
				stroke="#D1D2D4"
			/>
			<rect fill="#D0E3FC" height="80" width="120" x="8" y="8" />
			<path
				d="M68 42.75C68 42.3358 67.6642 42 67.25 42C66.8358 42 66.5 42.3358 66.5 42.75V53.25C66.5 53.6642 66.8358 54 67.25 54C67.6642 54 68 53.6642 68 53.25V42.75Z"
				fill="#73AAF6"
			/>
			<path
				d="M73.25 44.0671C75.4724 41.9361 80.4425 46.1544 73.25 51C66.0575 46.1544 71.0276 41.9361 73.25 44.0671Z"
				fill="#73AAF6"
			/>
			<path
				d="M59.75 43.5C59.3358 43.5 59 43.8358 59 44.25C59 44.6642 59.3358 45 59.75 45H64.25C64.6642 45 65 44.6642 65 44.25C65 43.8358 64.6642 43.5 64.25 43.5H59.75Z"
				fill="#73AAF6"
			/>
			<path
				d="M59.75 46.5C59.3358 46.5 59 46.8358 59 47.25C59 47.6642 59.3358 48 59.75 48H64.25C64.6642 48 65 47.6642 65 47.25C65 46.8358 64.6642 46.5 64.25 46.5H59.75Z"
				fill="#73AAF6"
			/>
			<path
				d="M59.75 49.5C59.3358 49.5 59 49.8358 59 50.25C59 50.6642 59.3358 51 59.75 51H64.25C64.6642 51 65 50.6642 65 50.25C65 49.8358 64.6642 49.5 64.25 49.5H59.75Z"
				fill="#73AAF6"
			/>
			<path
				clipRule="evenodd"
				d="M56 42C56 40.3431 57.3431 39 59 39H77C78.6569 39 80 40.3431 80 42V54C80 55.6569 78.6569 57 77 57H59C57.3431 57 56 55.6569 56 54V42ZM59 40.5C58.1716 40.5 57.5 41.1716 57.5 42V54C57.5 54.8284 58.1716 55.5 59 55.5H77C77.8284 55.5 78.5 54.8284 78.5 54V42C78.5 41.1716 77.8284 40.5 77 40.5H59Z"
				fill="#73AAF6"
				fillRule="evenodd"
			/>
		</svg>
	);
};


export default PostcardStandard;
